import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe, formatDate } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from '../_services/customer.service';
import { AccountService } from '../_services/account.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { ExcelService } from '../_helpers/index';

import { ParameterData } from '../_helpers/index';
import { Router, ActivatedRoute } from '@angular/router';
import { accountBankStatus, accountPSPCreation, accountPSPType, accountSettlementCreation, accountSettlementStatus } from '../_enums/account';
import { DataService } from '../_helpers/dataservice.service'
import { AuthService } from '../_services/auth.service';
import { SettlementProcessService } from '../_services/settlementProcess.service';
import { SettlementProcess } from '../_models';


@Component({
  selector: 'accountsoperationsettlement',
  templateUrl: './accountoperationsettlement.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})

export class AccountsOperationSettlementComponent implements OnInit, OnDestroy {

  public customer_public_id: string;
  public customer_Account_public_id: string;

  excelExportData: any;

  ddlCustomerAccount: any[];
  ddlCreation: any[];
  ddlStatus: any[];

  currentDate: Date;
  startDate: Date;
  endDate: Date;


  searchFilterForm: FormGroup;
  searchRangoFilterForm: FormGroup;
  displayedColumns: string[] = ['created', 'reference', 'account.name', 'transfer.reference', 'gross_amount.value', 'net_amount.value', 'status'];
  columnsToDisplay: string[] = this.displayedColumns.slice();
  dataSourceAccOperationSettlementList = new MatTableDataSource();
  selection = new SelectionModel<any>(true, []);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  customerPublic_key;
  isRangoVisiable = false;
  auth0Profile: any;

  isLoading = true;
  cust_account_name: any;

  /** This is Constructor function which is used to initialize the class variables and objects;
   */
  constructor
    (
      private router: Router, private formBuilder: FormBuilder,
      private _fb: FormBuilder, private excelService: ExcelService
      , private parameterData: ParameterData, private dataService: DataService
      , private datePipe: DatePipe
      , private accountService: AccountService
      , private auth: AuthService
      , private readonly activatedRoute: ActivatedRoute
      , private _accountBankStatus: accountBankStatus
      , private _accountPSPType: accountPSPType
      , private _accountpspcreation: accountPSPCreation
      , private settlementProcessService: SettlementProcessService
      , private customerService: CustomerService
      , private _accountsettlementcreation: accountSettlementCreation
      , private _accountsettlementstatus: accountSettlementStatus
    ) {


    this.ddlStatus = _accountBankStatus._accountBankStatus;
    this.ddlCreation = _accountpspcreation._accountpspcreation;
    this.isRangoVisiable = false;

  }//end




  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceAccOperationSettlementList.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSourceAccOperationSettlementList.data.forEach(row => this.selection.select(row));
  }





  /** This function is used to work the text filter above the grid;
   */
  applyFilter() {

    this.filterValue = this.searchFilterForm.controls.searchText.value;
    this.filterValue = this.filterValue.trim();
    this.filterValue = this.filterValue.toLowerCase();
    this.dataSourceAccOperationSettlementList.filter = this.filterValue;
  }//end


  /** This is ngOnInit function called after initialising the component;
 */
  ngOnInit() {

    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');

      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');

    }


    //////////////////////////


    //used to retrieve the customer Account public id
    let params: any = this.activatedRoute.snapshot.params;
    this.customer_Account_public_id = params.id;

    this.searchFilterForm = this.formBuilder.group({
      searchText: ['', Validators.required]
    });

    this.searchRangoFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });

    ///temp function
    this.GetCustomerAccountsOperationSettlementListNew();



    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";


    this.getCustomerAccountList();
    this.dataSourceAccOperationSettlementList.paginator = this.paginator;
    this.dataSourceAccOperationSettlementList.sort = this.sort;

    if (this._accountpspcreation._accountpspcreation.length > 8) {
      this._accountpspcreation._accountpspcreation.shift();
    }

  }//end

  ngOnDestroy() {

  }//end





  /** This function is used to get the account operation settlement list from the service;
   * it accepts the param customerId
   */
  GetCustomerAccountsOperationSettlementListNew() {



    this.currentDate = new Date();
    this.startDate = new Date();
    this.endDate = new Date();
    this.startDate.setDate(this.currentDate.getDate() - 400);
    this.endDate.setDate(this.currentDate.getDate() - 350);

    var strStartDate = formatDate(this.startDate, 'yyyy-MM-dd', 'en-UK');
    var strEndDate = formatDate(this.endDate, 'yyyy-MM-dd', 'en-UK');


    this.settlementProcessService.getSettlementReportList(this.customer_public_id, strStartDate, strEndDate).subscribe(data => {
      let resources = data["data"];
      this.isLoading = false;
      this.dataSourceAccOperationSettlementList.data = resources;
      this.excelExportData = resources;

    },
      error => {
        this.isLoading = false;
        console.log('Failed! while trying to get the settlement list. ' + error);
      });




  }//end





  /*
          * This function is used to get the customer account list from the service; *
     */
  getCustomerAccountList() {

    this.customerService.getCustomerAccountList(this.customer_public_id).subscribe(data => {
      let resourcesReturn = data;
      this.ddlCustomerAccount = resourcesReturn;
      this.ddlCustomerAccount = this.ddlCustomerAccount.filter(t => t.type === 'COLLECT');
    },
      error => {
        console.log('Failed while trying to the Search All Result. ' + error);
      });
  }//end


  GetCustomerAccountsOperationSettlementList() {

    this.settlementProcessService.getSettlementProcessList(this.customer_Account_public_id).subscribe(data => {
      let resources = data["data"];
      this.isLoading = false;
      this.dataSourceAccOperationSettlementList.data = resources;
      this.excelExportData = resources;
    },
      error => {
        this.isLoading = false;
        console.log('Failed! while trying to get the settlement list. ' + error);
      });
  }//end





  /** This function is used to export the operation settlement  list to the excel file;
   * it reads the data from the variable excelExportData which is assigened when the lits bind in to the grid
   */
  exportAsXLSX() {
    this.setExportExcelFileData(this.excelExportData);
  }//end


  setExportExcelFileData(excelExportData) {


    var excelHeader = ["FECHA", "REFERENCIA", "CUENTA", "OPERACION", "TOTAL", "TOTAL NETO", "ESTADO"]

    var arrFinalData = [];
    var object_temp = {};
    var k = 0;
    var columnsKeyNames = [];

    for (k = 0; k < excelExportData.length; k++) {
      var singleRec_temp = excelExportData[k];
      delete singleRec_temp['fees_amount'];
      delete singleRec_temp['id'];
      delete singleRec_temp['livemode'];
      delete singleRec_temp['object'];
      delete singleRec_temp['public_id'];
      delete singleRec_temp['tax_amount'];



      columnsKeyNames = Object.keys(singleRec_temp);



      var created_temp;
      var reference_temp;
      var account_temp;
      var operation_temp;
      var total_temp;
      var net_amount_temp;
      var status_temp;


      object_temp = {};

      for (var i = 0; i < columnsKeyNames.length; i++) {

        if (columnsKeyNames[i] == "created") {
          created_temp = singleRec_temp[columnsKeyNames[i]];
        }

        if (columnsKeyNames[i] == "settlement") {
          reference_temp = singleRec_temp[columnsKeyNames[i]].reference;
        }

        if (columnsKeyNames[i] == "account") {
          account_temp = "FIX";
          operation_temp = "FIX";
        }

        if (columnsKeyNames[i] == "gross_amount") {
          total_temp = singleRec_temp[columnsKeyNames[i]].value;
        }

        if (columnsKeyNames[i] == "net_amount") {
          net_amount_temp = singleRec_temp[columnsKeyNames[i]].value;
        }

        var statusEnglish;
        if (columnsKeyNames[i] == "status") {
          statusEnglish = singleRec_temp[columnsKeyNames[i]];

          switch (statusEnglish) {
            case 'NEW':
              status_temp = 'Nuevo'
              break;
            case 'PENDING':
              status_temp = 'Pendiente'
              break;
            case 'PROCESSING':
              status_temp = 'Pendiente'
              break;
            case 'CONFIRMED':
              status_temp = 'Confirmado'
              break;
            case 'CANCELLED':
              status_temp = 'Cancelado'
              break;
            case 'PAID':
              status_temp = 'Pagado'
              break;
            case 'VOIDED':
              status_temp = 'Anulado'
              break;
            case 'EXPIRED':
              status_temp = 'Expirado'
              break;
            case 'VOIDED_CUSTOMER':
              status_temp = 'Anulado'
              break;
            case 'OVERDUE':
              status_temp = 'Vencido'
              break;
            case 'PAYMENT_ON_HOLD':
              status_temp = 'Pendiente'
              break;
            default:
              status_temp = statusEnglish;

          }//end switch

        }



      }


      // for (var j = 0; j < excelHeader.length; j++) {
      //   if (excelHeader[j] == "Fecha") {
      //     object_temp[excelHeader[j]] = created_temp;
      //   }
      //   if (excelHeader[j] == "Referencia") {
      //     object_temp[excelHeader[j]] = reference_temp;
      //   }
      //   if (excelHeader[j] == "Cuenta") {
      //     object_temp[excelHeader[j]] = account_temp;
      //   }
      //   if (excelHeader[j] == "Operacion") {
      //     object_temp[excelHeader[j]] = operation_temp;
      //   }
      //   if (excelHeader[j] == "Total") {
      //     object_temp[excelHeader[j]] = total_temp;
      //   }
      //   if (excelHeader[j] == "Total Neto") {
      //     object_temp[excelHeader[j]] = net_amount_temp;
      //   }
      //   if (excelHeader[j] == "Estado") {
      //     object_temp[excelHeader[j]] = status_temp;
      //   }
      // }//end for excel header j


      arrFinalData.push([created_temp, reference_temp, account_temp, operation_temp, total_temp, net_amount_temp, status_temp]);

    }



    this.excelService.generateKashioExcelFile(excelHeader, arrFinalData, 'SettlementList');


  }//end function



  /*
   * This function is used to filter the invoices list based on Creation details based;
   * it accepts the param select Creation Date values
   */

  filterAccountCreationDetails(creation) {

    var currentDate = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    var lastweekFirstDate = new Date();
    var lastweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    var lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    var lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    lastweekFirstDate.setDate(currentweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);



    // All Datas Condition
    if (creation == 0) {
      this.dataSourceAccOperationSettlementList.filter = '';
    }

    // Current Month Filter Condition
    if (creation == 1) {
      this.dataSourceAccOperationSettlementList.filter = '';
      let CurrentmonthFirstDate = formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let CurrentmonthEndDate = formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccOperationSettlementList.filterPredicate = (data: SettlementProcess, filter: string) =>
        data.created >= CurrentmonthFirstDate && data.created <= CurrentmonthEndDate;

    }

    // Current Week Filter Condition
    if (creation == 2) {
      this.dataSourceAccOperationSettlementList.filter = '';
      let WeekstartDate = formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let WeekendDate = formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccOperationSettlementList.filterPredicate = (data: SettlementProcess, filter: string) =>
        data.created >= WeekstartDate && data.created <= WeekendDate;

    }

    // Today Filter Condition
    if (creation == 3) {
      this.dataSourceAccOperationSettlementList.filter = '';
      currentDate.setDate(currentDate.getDate());
      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let endDate = formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccOperationSettlementList.filterPredicate = (data: SettlementProcess, filter: string) =>
        data.created >= startDate && data.created <= endDate;
    }

    // Yesterday Filter Condition
    if (creation == 4) {
      this.dataSourceAccOperationSettlementList.filter = '';
      currentDate.setDate(currentDate.getDate() - 1);
      let startDate = formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let endDate = formatDate(currentDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccOperationSettlementList.filterPredicate = (data: SettlementProcess, filter: string) =>
        data.created >= startDate && data.created <= endDate;
    }


    // Last Week Filter Condition
    if (creation == 5) {
      this.dataSourceAccOperationSettlementList.filter = '';

      let lastWeekstartDate = formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let lastWeekendDate = formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');


      this.dataSourceAccOperationSettlementList.filterPredicate = (data: SettlementProcess, filter: string) =>
        data.created >= lastWeekstartDate && data.created <= lastWeekendDate;

    }

    // Last Month Filter Condition
    if (creation == 6) {
      this.dataSourceAccOperationSettlementList.filter = '';
      let LastmonthFirstDate = formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US');
      let LastmonthEndDate = formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:00', 'en-US');
      this.dataSourceAccOperationSettlementList.filterPredicate = (data: SettlementProcess, filter: string) =>
        data.created >= LastmonthFirstDate && data.created <= LastmonthEndDate;

    }
    if (creation != 0) {
      this.dataSourceAccOperationSettlementList.filter = '2018-10-24 01:59:45';
    }


    // Range Filter Condition
    if (creation == 7) {
      this.isRangoVisiable = true;
    }
    else {
      this.isRangoVisiable = false;
    }
  }//end



  /** This function is used to filter the Account list based on Status wise;
   * it accepts the param select status value
   */
  filterStatusDetails(status) {

    if (status == this.ddlStatus[0].value) {
      this.dataSourceAccOperationSettlementList.filter = '';
    }
    else if (status == this.ddlStatus[1].value) {
      this.dataSourceAccOperationSettlementList.filter = '';
      this.dataSourceAccOperationSettlementList.filterPredicate = (data: SettlementProcess, filter: string) =>
        data.status == 'NEW';
      this.dataSourceAccOperationSettlementList.filter = 'NEW';
    }
    else if (status == this.ddlStatus[2].value) {
      this.dataSourceAccOperationSettlementList.filter = '';
      this.dataSourceAccOperationSettlementList.filterPredicate = (data: SettlementProcess, filter: string) =>
        data.status == 'CONFIRMED';
      this.dataSourceAccOperationSettlementList.filter = 'CONFIRMED';
    }



  }//end


  /** This function is used to filter the Account list based on Status wise;
  * it accepts the param select status value
  */
  filterAccountNameDetails(status) {

    if (status == this.ddlStatus[0].value) {
      this.dataSourceAccOperationSettlementList.filter = '';
    }
    else {
      this.dataSourceAccOperationSettlementList.filter = '';
      this.dataSourceAccOperationSettlementList.filterPredicate = (data: SettlementProcess, filter: string) =>
        data.status == 'NEW';
      this.dataSourceAccOperationSettlementList.filter = 'NEW';
    }




  }//end


  /** This function is used to filter the invoices list based on Experience Rango From and To Date wise;
     * it accepts the param select status value
     */
  filterRangoExpDetails() {

    if (this._accountpspcreation._accountpspcreation.length > 8) {
      this._accountpspcreation._accountpspcreation.shift();
    }

    this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");

    this.ddlCreation.unshift({ value: 9, name: this.filterValue });


    this.isRangoVisiable = false;


    this.dataSourceAccOperationSettlementList.filter = '';
    let CurrentmonthFirstDate = formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US');
    let CurrentmonthEndDate = formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:00', 'en-US');
    this.dataSourceAccOperationSettlementList.filterPredicate = (data: SettlementProcess, filter: string) =>
      data.created >= CurrentmonthFirstDate && data.created <= CurrentmonthEndDate;

    this.dataSourceAccOperationSettlementList.filter = '2018-10-24 01:59:45';


  }//end







}//end class


